import Http from '../index'
import Model from '../Model.js'

import ClientFeatures from './ClientFeatures.js'
class Features extends Model {
  constructor() {
    super('/features/')
    this.knownFlags = []
  }

  async list() {
    this.knownFlags = []
    const resp = await Http.get(`${this.model}`)
    for (const flag of resp.data.results) {
      this.knownFlags.push(flag.name)
    }
    return resp
  }

  async getFeaturesByClient(linkId, isAdmin) {
    await this.list()
    if (isAdmin && !linkId) {
      return Features.knownFlags
    }
    const promises = this.knownFlags.map(async flag => {
      const resp = await ClientFeatures.getFeatureValueForClient(linkId, flag)
      if (resp.data.value === true) {
        return flag
      }
      return null
    })

    return await Promise.all(promises)
  }
}

export default new Features()
